// 日期选择器中文语言包
export const datePickerLocale = {
  formatLocale: {
    months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    monthsShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
    weekdays: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
    weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
    weekdaysMin: ['日', '一', '二', '三', '四', '五', '六'],
    firstDayOfWeek: 0,
    firstWeekContainsDate: 1,
    meridiem: ['上午', '下午'],
    meridiemParse: /[AP]\.?M?\.?/i,
    isPM: function (input) {
      return /^P/i.test(input);
    }
  },
  yearFormat: 'YYYY年',
  monthFormat: 'YYYY年MM月',
  monthBeforeYear: true
};

